import { Button, Col, Modal, Row } from 'antd';
import moment from 'moment';
import React, { useState } from "react";
import {
    injectIntl
} from "react-intl";
import { withRouter } from "react-router-dom";
import {
    Card,
    CardBody,
    CardHeader
} from "../../../_metronic/_partials/controls";
import { formatCoinID, formatMoney } from '../../lib/common';

function DetailSwapTON(props) {

    const [modalCancel, setModalCancel] = useState(false)
    const [modalConfrim, setModalConfrim] = useState(false)
    const { visibleModal, onCloseModal, recordModal, filterModal } = props

    const renderType = (key) => {
        switch (key) {
            case "by_order":
                return "Phí Mua Hàng"
            case "deposit":
                return "Nạp Tiền"
            case "swap_gold_money":
                return "Bán Vàng"
            case "swap_money_gold":
                return "Mua Vàng"
            case "withdraw_gold":
                return "Rút Vàng"
            default:
                return ""
        }
    }

    const renderStatus = (status) => {
        switch (status) {
            case 0: {
                return "Chờ duyệt"
            }
            case 1: {
                return "Thành công"
            }
            case 2: {
                return "Hoàn thành"
            }
            case -1: {
                return "Ngừng giao dịch"
            }
            default:
                break;
        }
    }

    const convertType = (value)=>{
        if(value === 'swap_XAU_USD'){
            return 'Bán XAUT'
        }else{
            return 'Mua XAUT'
        }
    }
    return (
        <Modal visible={visibleModal}
            bodyStyle={{ position: "relative" }} onCancel={onCloseModal} style={{ top: 0 }}
            centered={true}
            footer={recordModal?.status === 1 && recordModal?.type === "deposit" ?
                (<div>
                    <Button type="primary" danger onClick={() => setModalCancel(true)}>Hủy</Button>
                    <Button type="primary" onClick={() => setModalConfrim(true)} >Duyệt</Button>
                </div>)
                :
                recordModal?.status === 0 && recordModal?.type === "deposit" ?
                    (<div>
                        <Button type="primary" danger onClick={() => setModalCancel(true)}>Hủy</Button>
                        <Button type="primary" onClick={() => setModalConfrim(true)}>Duyệt</Button>
                    </div>)
                    : null
            }
        >
            <Card>
                <CardHeader title={`Trạng thái: ${renderStatus(recordModal?.status)}`} >
                </CardHeader>
                <CardBody>
                    <Col span={24}>
                        <div style={{ fontSize: 18, marginBottom: 12 }} className="customLabel">Thông tin {(renderType(recordModal?.type)).toLowerCase()}</div>
                        <Row style={{ marginBottom: "10px" }}>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Người gửi:</lable>
                                <div>{recordModal?.user?.fullname || "--"}</div>
                                <div>{recordModal?.user?.email || "--"}</div>
                                <div>{recordModal?.user?.mobile || "--"}</div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Loại giao dịch:</lable>
                                <div>{convertType(recordModal?.type) || "--"}</div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Giá trị nhận:</lable>
                                <div>{`${formatCoinID(((recordModal?.amount/recordModal?.price) || 0), 5)}` || "--"}</div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Phí chuyển:</lable>
                                {Number(recordModal?.fee || 0) !== 0 ? <div>{formatMoney(recordModal?.fee || 0) || ""}</div> : <div>Miễn phí</div>}
                            </Col>
                        </Row>
                        <Row >
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Mã giao dịch:</lable>
                                <div>{recordModal?.comment   || ""}</div>
                            </Col>
                            <Col style={{ marginBottom: "10px" }} span={12}>
                                <lable className="customLabel">Ngày chuyển:</lable>
                                <div>{recordModal?.createdAt ? moment(recordModal?.createdAt).format('DD/MM/YYYY HH:mm:ss') : ""}</div>
                            </Col>
                        </Row>
                    </Col>
                </CardBody>
            </Card>
        </Modal >

    );
}

export default injectIntl(withRouter(DetailSwapTON));
